// Mapping of brain_type (1-9) → name + graphic URL.
// Graphics 6-9 will be added once the user uploads them.
export const BRAIN_TYPE_GRAPHICS = {
  1: {
    name: "The Perfectionist",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-tracker-pro-31/artifacts/mwgqp6tt_Braintype%201%20-%20Perfectionist%20without.png",
  },
  2: {
    name: "The Helper",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-tracker-pro-31/artifacts/jwx5o8jm_Braintype%202%20-%20Helper%20without.png",
  },
  3: {
    name: "The Successful Worker",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-tracker-pro-31/artifacts/gpjct92e_Braintype%203%20-%20Successful%20Worker%20without.png",
  },
  4: {
    name: "The Romantic",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-tracker-pro-31/artifacts/xdp3atc4_Braintype%204%20-%20Romantic%20without.png",
  },
  5: {
    name: "The Analyst",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-tracker-pro-31/artifacts/mnwuz9pc_Braintype%205%20-%20Analyst%20without.png",
  },
  6: {
    name: "The Loyalist",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-tracker-pro-31/artifacts/441u6951_Braintype%206%20-%20Loyalist%20without.png",
  },
  7: {
    name: "The Hedonist",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-tracker-pro-31/artifacts/1hkwxdp8_Braintype%207%20-%20Hedonist%20without.png",
  },
  8: {
    name: "The Boss",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-tracker-pro-31/artifacts/pu6v7i04_Braintype%208%20-%20Boss%20without.png",
  },
  9: {
    name: "The Mediator",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-tracker-pro-31/artifacts/tsnffhsr_Braintype%209%20-%20Mediator%20without.png",
  },
};

export function brainTypeMeta(n) {
  if (n == null) return null;
  return BRAIN_TYPE_GRAPHICS[n] || null;
}
